import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

/**
 * NotFound — 404 Not Found 페이지 컴포넌트
 *
 * 존재하지 않는 경로에 접근했을 때 표시되며,
 * 홈으로 돌아가기 링크를 제공한다.
 *
 * @returns {React.ReactElement}
 *
 * Validates: Requirements 1.5
 */
const NotFound = () => {
  return (
    <div className="empty-state">
      <div className="empty-state-icon"><Icon name="search" size={48} /></div>
      <h1 className="empty-state-title">404 - 페이지를 찾을 수 없습니다</h1>
      <p className="empty-state-description">
        요청하신 페이지가 존재하지 않거나 이동되었습니다.
      </p>
      <Link to="/" className="btn-primary" style={{ display: 'inline-block', marginTop: '16px', textDecoration: 'none' }}>
        홈으로 돌아가기
      </Link>
    </div>
  );
};

export default NotFound;
